<template>
    <div class="item" @click="$emit('onClick')">
      <img :src="images" alt="">
      <div class="mask">
        <div class="box">
          <div class="title">{{title}}</div>
          <div class="desc">{{desc}}</div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "project-item",
        props:{
          images: {
            type: String,
            default: ''
          },
          title: {
            type: String,
            default: ''
          },
          desc: {
            type: String,
            default: ''
          }
        }
    }
</script>

<style lang="less" scoped>
  .item{
    width: 100%;
    height: 100%;
    border-radius: 3px;
    position: relative;
    background-color: rgba(0,0,0,.8);
    overflow: hidden;
    /*background-color: #cbcbcb;*/
    img{
      width: 100%;
      height: 100%;
    }
    .mask{
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: rgba(0, 0, 0, .6);
      color: #ffffff;
      align-self: flex-end;
      text-align: left;
      .box{
        position: absolute;
        bottom: 15px;
        left: 15px;
        right: 15px;
        .title{
          border-bottom: solid 2px #ffffff;
          max-width: max-content;
          padding: 5px 0;
          margin: 5px 0;
          font-weight: bolder;
          font-size: 18px;
        }
        .desc{
          font-size: 16px;
        }
      }

    }
  }
  .item:hover{
    .mask{
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/project-item.vue